export const C={bg:"#F4F6FA",card:"#FFFFFF",bdr:"#E2E8F0",acc:"#0F172A",txt:"#0F172A",sub:"#94A3B8",sub2:"#64748B",ok:"#0F766E",warn:"#D97706",red:"#DC2626",fn:"'Noto Sans KR','Apple SD Gothic Neo',sans-serif"};

export const CATS=["이너","아우터","팬츠","니트","원피스","스커트","기타"];
export const CAT_C={이너:"#0F172A",아우터:"#0F172A",팬츠:"#0F172A",니트:"#0F172A",원피스:"#0F172A",스커트:"#0F172A",기타:"#64748B"};

export const VEN_TYPES=["원단","안감","단추","지퍼","심지","기타"];
export const VEN_IC={원단:"•",안감:"•",단추:"•",지퍼:"•",심지:"•",기타:"•"};
export const VEN_C={원단:"#0F172A",안감:"#0F172A",단추:"#0F172A",지퍼:"#0F172A",심지:"#0F172A",기타:"#64748B"};

export const SEASONS=["26SS","26FW","25SS","25FW"];
export const MAT_TYPES=["메인원단","부속원단","단추","지퍼","안감","심지","기타"];
export const BIZ_TYPES=["다이마루","직기","니트","데님","기타"];

export const DASH_NOTICES=[
  "최근 발주 빠른 불러오기 기능 추가",
  "업체별 개별 메모 기능 추가",
  "발주내역 일괄 선택/완료/보관 기능 추가"
];
